import { Send } from "lucide-react"
import { LinkBtn } from "../../../buttons"

interface Props {
  takeOverConversation: () => void
  sendReply: () => void
  message: string
  setReplyMessage: (msg: string) => void
}

const LOFooter = ({
  takeOverConversation,
  sendReply,
  message,
  setReplyMessage
}: Props) => {
  const handleSendReply = () => {
    sendReply()
  }

  const handleEnterKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSendReply()
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReplyMessage(e.target.value)
  }

  return (
    <div className="flex">
      <input
        type="text"
        value={message}
        onChange={handleChange}
        onKeyDown={handleEnterKey}
        className="appearance-none block w-full px-3 py-2.5 rounded-lg bg-neutral-50 border-neutral-50 input-base"
        placeholder="Type message here…"
      />
      <LinkBtn className="ml-2" onClick={handleSendReply} text="base">
        <span className="sr-only">Send</span>
        <Send className="w-6 h-6" />
      </LinkBtn>
      <LinkBtn
        className="ml-2 whitespace-nowrap hover:no-underline"
        text="base"
        onClick={takeOverConversation}
      >
        Handover to AI
      </LinkBtn>
    </div>
  )
}

export default LOFooter
